import { call, put, all, takeLatest } from "redux-saga/effects";
import * as api from "constants/api";
import { handleError } from "./ApiError";
import {
	GET_ADMIN_ASSIGNEES,
	SG_GET_ADMIN_ASSIGNEES,
	FETCH_ADMIN_ASSIGNEE,
	SG_FETCH_ADMIN_ASSIGNEE,
	ADD_ADMIN_ASSIGNEE,
	SG_ADD_ADMIN_ASSIGNEE,
	EDIT_ADMIN_ASSIGNEE,
	SG_EDIT_ADMIN_ASSIGNEE,
	DELETE_ADMIN_ASSIGNEE,
	SG_DELETE_ADMIN_ASSIGNEE,
} from "constants/actions";

/* Admin Assignees */

function* loadAssignees(action) {
	try {
		const json = yield call(api.GET_APV2_ASSIGNEES, action.payload);
		yield put({ type: GET_ADMIN_ASSIGNEES, payload: json.data });
	} catch (e) {
		yield call(handleError, e);
	}
}

export function* assigneesLoad() {
	yield takeLatest(SG_GET_ADMIN_ASSIGNEES, loadAssignees);
}

function* fetchAssignee(action) {
	try {
		const json = yield call(api.FETCH_APV2_ASSIGNEE, action.payload);
		yield put({ type: FETCH_ADMIN_ASSIGNEE, payload: json.data });
	} catch (e) {
		yield call(handleError, e);
	}
}

export function* assigneeFetch() {
	yield takeLatest(SG_FETCH_ADMIN_ASSIGNEE, fetchAssignee);
}

function* addAssignee(action) {
	try {
		const json = yield call(api.ADD_APV2_ASSIGNEE, action.payload);
		yield put({ type: ADD_ADMIN_ASSIGNEE, payload: json.data });
	} catch (e) {
		yield call(handleError, e);
	}
}

export function* assigneeAdd() {
	yield takeLatest(SG_ADD_ADMIN_ASSIGNEE, addAssignee);
}

function* editAssignee(action) {
	try {
		const json = yield call(api.EDIT_APV2_ASSIGNEE, action.payload);
		yield put({ type: EDIT_ADMIN_ASSIGNEE, payload: json.data });
	} catch (e) {
		yield call(handleError, e);
	}
}

export function* assigneeEdit() {
	yield takeLatest(SG_EDIT_ADMIN_ASSIGNEE, editAssignee);
}

function* deleteAssignee(action) {
	try {
		const json = yield call(api.DELETE_APV2_ASSIGNEE, action.payload);
		yield put({ type: DELETE_ADMIN_ASSIGNEE, payload: json.data });
	} catch (e) {
		yield call(handleError, e);
	}
}

export function* assigneeDelete() {
	yield takeLatest(SG_DELETE_ADMIN_ASSIGNEE, deleteAssignee);
}

export default function* index() {
	yield all([
		assigneesLoad(),
		assigneeFetch(),
		assigneeAdd(),
		assigneeEdit(),
		assigneeDelete(),
	]);
}

